// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1PDFZ","title":"Images45_title__3rAr6","images":"Images45_images__2xYi_"};